export default {
  messages: [],
  message: {},
  user: {},
  content: ''
}
